import theme from '../../styles/theme';
export const expandAtSizes = theme.breakpointNames;
export const sizes = {
    large: 'large',
    medium: 'medium',
    small: 'small',
};
export const types = {
    primary: 'primary',
    secondary: 'secondary',
    tertiary: 'tertiary',
};
